import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';

const leftPadding = 16;
const selectedOptionPadding = 15;

export const wrapper = css({
  position: 'relative',
  width: '100%',
});

export const fieldContainerCss = {
  background: colorsPalette.white,
  padding: `25px ${leftPadding}px 9px`,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: '4px',

  '&[data-focus="true"]': {
    border: `1px solid ${colorsPalette.teal}`,
  },

  '&[data-error="true"]': {
    border: `1px solid ${colorsPalette.red120}`,
  },

  '&[data-disabled="true"]': {
    border: `1px solid ${colorsPalette.grey20}`,
    background: colorsPalette.grey10,
  },
  'input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
  },
};

export const iconAlignmentCss = css({
  display: 'flex',
  alignItems: 'center',
});

export const labelCss = css(typography.effra18, {
  position: 'absolute',
  color: colorsPalette.grey60,
  top: 0,
  left: leftPadding,
  transform: 'translateY(50%)',
  transition: 'transform 0.4s',
  transformOrigin: 'top left',

  '&[data-shrink="true"]': {
    transform: 'translateY(10%) scale(0.75)',

    '&[data-error="true"]': {
      color: colorsPalette.red120,
    },
  },

  '&[data-focus="true"]': {
    color: colorsPalette.teal,
  },
});

export const inputButtonCss = css({
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  position: 'relative',
  width: 30,
  height: 20,
});

export const inputIconCss = css({
  top: -7,
  position: 'absolute',
  right: 0,
  color: colorsPalette.grey60,
  '&:before': {
    fontSize: 20,
  },
});

export const fieldCss = css(typography.effra18, {
  border: 'none',
  background: colorsPalette.transparent,
  outline: 'none',
  padding: 0,
  margin: 0,
  width: 'calc(100% - 40px)',
});

export const errorCss = css(typography.effra14, {
  color: colorsPalette.red120,

  '&[data-disabled="true"]': {
    color: colorsPalette.grey60,
  },
});

export const selectIconCss = css({
  fontSize: 10,
  color: colorsPalette.grey,
  position: 'absolute',
  right: selectedOptionPadding,
  top: '50%',
  transform: 'translateY(-50%)',
});

export const selectInputCss = css({
  display: 'block',
  position: 'absolute',
  cursor: 'pointer',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: '100%',
  width: '100%',
  outline: 'none',
  background: colorsPalette.transparent,
  border: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',

  '&:focus': {
    outline: 'none',
  },
});

export const errorContainerCss = css({
  position: 'relative',
});
